import moment from 'moment/moment'
type DateOrMoment = Date | moment.Moment

export const datePickerValidators = {
  DATE_PAST_ONLY: (d: DateOrMoment) => d && d > moment().endOf('day'),
  DATE_FUTURE_ONLY: (d: DateOrMoment) => d && d < moment().startOf('day'),
  TIME_FUTURE_ONLY: () => {
    const hour = moment().hour()
    const disabledHours = Array.from({ length: hour + 1 }, (_, i) => i)
    return {
      disabledHours: () => disabledHours,
    }
  },
  HOURS_PAST_ONLY: () => {
    const hour = moment().hour() + 1
    const disabledHours = Array.from({ length: 24 - hour }, (_, i) => i + hour)
    return disabledHours
  },
  MINUTES_PAST_ONLY: (selectedHour: number) => {
    const minutes = []
    const currentMinute = moment().minute() + 1
    if (selectedHour === moment().hour()) {
      for (let i = currentMinute; i <= 60; i++) {
        minutes.push(i)
      }
    }
    return minutes
  },
}
